import React, { useState } from 'react';
import { Tag, Input, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

interface ChronicDiseasesInputProps {
  value?: string[];
  onChange?: (value: string[]) => void;
  placeholder?: string;
  disabled?: boolean;
  maxTags?: number;
}

const ChronicDiseasesInput: React.FC<ChronicDiseasesInputProps> = ({
  value = [],
  onChange,
  placeholder = "Kronik hastalık eklemek için yazın ve Enter'a basın",
  disabled = false,
  maxTags = 10
}) => {
  const [inputValue, setInputValue] = useState('');
  const [isInputVisible, setIsInputVisible] = useState(false);

  // value undefined ise boş array kullan
  const diseases = value || [];

  const handleAddDisease = () => {
    if (inputValue.trim() && !diseases.includes(inputValue.trim()) && diseases.length < maxTags) {
      const newDiseases = [...diseases, inputValue.trim()];
      onChange?.(newDiseases);
      setInputValue('');
      setIsInputVisible(false);
    }
  };

  const handleRemoveDisease = (diseaseToRemove: string) => {
    const newDiseases = diseases.filter(disease => disease !== diseaseToRemove);
    onChange?.(newDiseases);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddDisease();
    }
  };

  return (
    <div className="chronic-diseases-input" style={{ minHeight: '40px', width: '100%' }}>
      <div className="d-flex flex-wrap gap-2 mb-2">
        {diseases?.map((disease) => (
          <Tag
            key={disease}
            closable={!disabled}
            onClose={() => handleRemoveDisease(disease)}
            color="blue"
            style={{ marginBottom: '4px' }}
          >
            {disease}
          </Tag>
        ))}
      </div>
      
      {!disabled && diseases?.length < maxTags && (
        <div className="add-disease-section">
          {isInputVisible ? (
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <Input
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder={placeholder}
                style={{ width: '250px', minWidth: '200px' }}
                autoFocus
                size="small"
              />
              <Button
                type="primary"
                size="small"
                onClick={handleAddDisease}
                disabled={!inputValue.trim()}
              >
                Ekle
              </Button>
              <Button
                size="small"
                onClick={() => {
                  setIsInputVisible(false);
                  setInputValue('');
                }}
              >
                İptal
              </Button>
            </div>
          ) : (
            <Button
              type="dashed"
              onClick={() => setIsInputVisible(true)}
              icon={<PlusOutlined />}
              size="small"
              style={{ marginTop: diseases?.length > 0 ? '8px' : '0' }}
            >
              Kronik hastalık ekle
            </Button>
          )}
        </div>
      )}
      
      {diseases?.length === 0 && !isInputVisible && (
        <div className="text-muted small" style={{ marginTop: '8px' }}>
          Kronik hastalığınız yoksa bu alanı boş bırakabilirsiniz.
        </div>
      )}
    </div>
  );
};

export default ChronicDiseasesInput; 